<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-body">
        <div class="modal-header">
          <div class="top-header">
            <h3>GIVE PRO</h3>
            <i class="fas fa-times" @click="closeModal()"></i>        
          </div>
          <div class="bottom-header">
            <img
              v-if="getUserPicture() !== ''"
              :src="getUserPicture()"
              class="user-profile"
            />
            <div v-else class="blank-image"></div>
            <div class="user-details">
              <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
              <p>{{ formatDate(selectedUser.updated_at) }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="top-row">
          <label>
            <img class="icon" src="../../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
            Pro Duration
          </label>
          <select v-model="durationValue">
            <option value="">Select a duration</option>
            <option value="monthly">1 Month</option>
            <option value="two_month">2 Month</option>
            <option value="three_month">3 Month</option>
            <option value="six_month">6 Month</option>
            <option value="yearly">1 Year</option>
            <option value="lifetime">Lifetime</option>
          </select>
        </div>
        <div class="buttons">
          <button class="secondary-btn-dark" @click="closeModal()">
            DISCARD
          </button>
          <button @click="savePro()" class="primary-btn">
            CONFIRM PRO
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils'
import { grantPro } from '@/api/requests';

export default {
  name: "UserProPrompt",

  data() {
    return {
      durationValue: '',
    };
  },

  methods: {
    closeModal() {
      this.$store.dispatch('users/closeProPrompt');
    },

    getUserPicture() {
      if (this.selectedUser.image !== "" && this.selectedUser.image !== null) {
        if (this.selectedUser.image.indexOf('blob:') > -1) {
          return this.selectedUser.image;
        }

        return this.url + this.selectedUser.image;
      }
      return "";
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    savePro() {
      if (this.durationValue !== '') {
        const params = {
          duration: this.durationValue,
        };
        grantPro(this.selectedUser.id, params).then(() => {
          this.$store.dispatch('reloadTable');
          this.closeModal();
          this.$toasted.global.app_success({
            message: "User has been given Pro access."
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to grant Pro access."
          });
        });
      } else {
        this.$toasted.global.app_error({
          message: "Select a duration."
        });
      }
    }
  },

  computed: {
    selectedUser() {
      return this.$store.state.users.selectedUser;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .modal-container {
    background: $sec0;
    width: 30%;
    margin-left: 35%;
    margin-top: 250px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .modal-body {
      background: $sec0;
      padding: $spacing-base;

      .modal-header {
        display: flex;
        align-items: center;
        flex-direction: column;

        .top-header {
          display: flex;
          width: 100%;
          margin-bottom: $spacing-small;
          h3 {
            flex: 1;
            color: #FFF;
            padding: 0;
            margin: 0;
            font-size: $font-size-medium;
            display: inline-block;
          }
        }

        .bottom-header {
          display: flex;
          width: 100%;
        }

        .user-details {
          flex: 1;
          margin-left: $spacing-base;
          display: flex;
          flex-direction: column;

          h3 {
            flex: 1;
            color: #FFF;
            padding: 0;
            margin: 0;
            font-size: $font-size-base;
            display: inline-block;
          }

          p {
            margin: 0;
            padding: 0;
            font-size: $font-size-small;
            color: $sec4;
          }
        }

        .blank-image {
          width: 30px;
          height: 30px;
          border-radius: 30px;
          background: $sec7;
        }

        .user-profile {
          display: inline-block;
          border-radius: 30px;
          width: 30px;
          height: 30px;
        }
        .icon {
          margin-left: -14px;
          margin-top: -50px;
        }
        i {
          color: $sec4;
          cursor: pointer;
        }
      }

      .modal-row {
        display: flex;
        margin-bottom: $spacing-base;
        gap: $spacing-small;
        label {
          display: block;
          color: $sec6;
          font-size: $font-size-x-small;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 2px;
        }

        span {
          color: $sec4;
          font-size: $font-size-small;
        }
      }

      .modal-input {
        flex: 1;
      }
    }
  }
}

.picture-option {
  margin-left: 0;
}

.modal-footer {
  background: $sec1;
  padding: $spacing-base;
  display: flex;
  flex-direction: column;
  gap: $spacing-small;

  .delete-btn {
    background: $sec0;
    color: $sec2;
    border: 0;
    border-radius: 0;
    font-weight: bold;
    height: 24px;
    font-size: $font-size-x-small;
    cursor: pointer;
  }
  
  .top-row {
    width: 100%;
    display: flex;
    flex-direction: column;
    label {
      color: $sec5;
      font-weight: 500;
      font-size: $font-size-base;
      margin-bottom: $spacing-small;
    }
  }

  .bottom-row {
    display: flex;
    button {
      flex: 1;
      border: 1px solid $sec2;
    }

    .ban-user {
      flex: 2;
      border-right: 0;
    }
  }
  button {
    // width: 45%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    i {
      display: block;
      margin-bottom: $spacing-small;
    }
    img {
      display: block;
      width: 12px;
      margin-bottom: $spacing-small / 2;
    }
  }
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>